var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import manualAssetCreate from '../../requests/asset/manualAssetCreate';
/**
 *
 */
var CreateManualAssetCommand = /** @class */ (function (_super) {
    __extends(CreateManualAssetCommand, _super);
    function CreateManualAssetCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param initialManualAssetModel InitialManualAssetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    CreateManualAssetCommand.prototype.execute = function (initialManualAssetModel, organisationId, intl) {
        this.intl = intl;
        this.initialManualAssetModel = initialManualAssetModel;
        var promise = manualAssetCreate(initialManualAssetModel, organisationId);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    CreateManualAssetCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.added' }, Object(this.initialManualAssetModel)), 'dark', true);
    };
    return CreateManualAssetCommand;
}(Command));
export default CreateManualAssetCommand;
